// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from "vue-i18n"
import ElementUI from "element-ui"
import utils from "./common/js/utils";

// localForage有一个优雅的降级策略，如果浏览器不支持indexedDB或者WebSQL则使用localStorage
import localForage from "localforage";

import zh from "./common/language/zh.js";
import en from "./common/language/en.js";
import "animate.css";
import "element-ui/lib/theme-chalk/index.css";
import "./common/css/index.css";
import './assets/css/reset.css';
import "./lib/storage.js"
Vue.config.productionTip = false
Vue.use(VueI18n);
Vue.use(ElementUI);
const i18n = new VueI18n({
  locale: localStorageProxy.getItem("languageType") || "zh",
  messages: {
    zh,
    en,
  },
});
Vue.prototype.$success = utils.success; //全局注册成功弹窗
Vue.prototype.$error = utils.error; //全局注册错误弹窗
Vue.prototype.$warning = utils.warning; //全局注册警告弹窗
Vue.prototype.utils = utils;
Vue.prototype.$version = "2.0.3";
Vue.prototype.$localForage = localForage;
Vue.prototype.$linkBtn = Global.linkBtn || [];

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js